import { useQuery } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { getAppDownloadLinks } from "../../../queries/communications";

interface AppDownloadLinksType {
  appleLink?: string;
  googleLink?: string;
}

export function useNotifyAppDownloadLinks() {
  const networkHeaders = useNetworkHeaders();
  const { data: downloadLinks, isLoading: isDownloadLinksLoading } = useQuery<AppDownloadLinksType>(
    buildAppDownloadLinksQueryKey(),
    getAppDownloadLinks(networkHeaders),
    {
      queryFnParamsFilter(args) {
        return [args[1]];
      },
      keepPreviousData: true,
    },
  );

  return { downloadLinks, isDownloadLinksLoading };
}

export function buildAppDownloadLinksQueryKey() {
  return "notifyAppDownloadLinks";
}
